import { PedidoSap } from '@models/pedido-sap.model';
import { deburr, toLower } from 'lodash';

export const autocompleteFilterDeburr = (
  item: unknown,
  queryText: string,
  itemText: string,
): boolean => {
  const queryDeburr = deburr(toLower(queryText || ''));
  const itemDeburr = deburr(toLower(itemText || ''));
  return itemDeburr.indexOf(queryDeburr) > -1;
};

export const autocompleteFilterPedido = (
  item: PedidoSap,
  queryText: string,
  itemText: string,
): boolean => {
  return (
    item.pedidoCompra
      .toLocaleLowerCase()
      .indexOf(queryText.toLocaleLowerCase()) > -1 ||
    item.fornecedorSap.identificacao
      .toLocaleLowerCase()
      .indexOf(queryText.toLocaleLowerCase()) > -1 ||
    item.fornecedorSap.nome
      .toLocaleLowerCase()
      .indexOf(queryText.toLocaleLowerCase()) > -1
  );
};
